module.exports = __webpack_public_path__ + "static/media/icon_1.2c31219b.svg";